<div class="container">
    <div class="row d-flex flex-wrap">

        <div class="col-12 col-sm-12 col-md-3">
            <h2 class="orange-header">Create Invoice</h2>
            <p>Create and send customised invoices</p><br>

            <h3>Use This When:</h3>
            <ul>
                <li>you need an official invoice</li>
                <li>send via email (credits needed) or via WhatsApp (free)</li>
            </ul>

            <h3>Your customer will receive:</h3>
            <ul>
                <li>a customised invoice with the payment options automatically added</li>
            </ul>
        </div>

        <div class="col-12 col-sm-12 col-md-9 justify-content-center align-self-center">
            <img [ngSrc]="'walkthrough-create-invoice.gif' | assetSource"
                 alt="quick pay image"
                 class="walkthrough-image responsive-gif"
                 height="1"
                 width="1"/>
        </div>
    </div>
</div>